import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css`
    width: 100%;
  `,
  shareButtons: css`
    width: 100%;
  `,
}));

export const useButtonGroupSharedStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
